/**
 * Common method to check if value/data is empty or null
 * @param value Data value to check
 * @returns If value is empty or null then true, otherwise false
 */
export const isNullOrEmpty = (value: any) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return true
  }
  if (typeof value === 'string') {
    return value.trim() === ''
  }
  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return value.length === 0
    }
    return Object.keys(value)?.length === 0
  }
  return false
}

export const capitalizeFirstCharOfWord = (str: string): string => {
  if (isNullOrEmpty(str?.trim())) {
    return "";
  }

  return str
    .trim()
    .split(" ") // Split the string into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
    .join(" "); // Join the words back with a space
};


